import React, { Component } from 'react';
import { Card, Col } from 'reactstrap';
// import './media.scss';
import getConfig from 'next/config';
import Slider from 'react-slick';

const config = getConfig().publicRuntimeConfig;

const MediaDesktopsettings = {
	dots: true,
	// infinite: true,
	speed: 500,
	slidesToShow: 3,
	slidesToScroll: 1,
	autoplay: true,
	// autoplaySpeed: 5000,
	arrows: false,
	appendDots: dots => (
		<div>
			<ul> {dots} </ul>
		</div>
	),
	customPaging: i => <div className="dot-item"></div>
	// responsive: [
	// 	{
	// 		breakpoint: 1023,
	// 		settings: {
	// 			slidesToShow: 2,
	// 			slidesToScroll: 1,
	// 			// infinite: true,
	// 			dots: true
	// 		}
	// 	},
	// 	{
	// 		breakpoint: 767,
	// 		settings: {
	// 			slidesToShow: 1,
	// 			slidesToScroll: 1,
	// 			// initialSlide: 1,
	// 			dots: true
	// 		}
	// 	}
	// ]
};

const MediaMobilesettings = {
	dots: true,
	// infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	// autoplaySpeed: 5000,
	arrows: false,
	appendDots: dots => (
		<div>
			<ul> {dots} </ul>
		</div>
	),
	customPaging: i => <div className="dot-item"></div>
	// responsive: [
	// 	{
	// 		breakpoint: 1023,
	// 		settings: {
	// 			slidesToShow: 2,
	// 			slidesToScroll: 1,
	// 			// infinite: true,
	// 			dots: true
	// 		}
	// 	},
	// 	{
	// 		breakpoint: 767,
	// 		settings: {
	// 			slidesToShow: 1,
	// 			slidesToScroll: 1,
	// 			// initialSlide: 1,
	// 			dots: true
	// 		}
	// 	}
	// ]
};

export default class index extends Component {
	mediaPanelCard = items =>
		items.map((item, idx) => {
			return (
				<Col className="" key={idx} className="media-card-for-mobile">
					<a
						href={item.blogUrl}
						rel="nofollow"
						onClick={() => {
							const eventInfo = {
								name : item.heading
							}
							if (window.eventDispatcher) {
								window.eventDispatcher.dispatchEventSync(
									'media-panel-card',
									eventInfo,
									{ amplitude: true }
								);
							}
						}}
						style={{ textDecoration: 'none' }}
					>
						<Card
							className="missions-card in-news-panel"
							style={{ boxShadow: '0 0 7px 0 rgb(0 0 0 / 25%)' }}
						>
							<div style={{ position: 'relative' }}>
								<img
									style={{ width: '100%' }}
									src={`${config.cdnUrl}${item.src}`}
									alt={item.heading}
								/>
							</div>
							<div className="">
								<div className="missions-card-container">
									<p
										className="media-card-homepage"
										style={{ color: '#444', marginBottom: '3px' }}
									>
										<b>{item.heading}</b>
									</p>
									<p className="media-card-date">{item.date}</p>
								</div>
								<div
									className="logo-block"
									style={{ borderTop: '1px solid #f2f2f2' }}
								>
									<div className="img-container">
										<img src={`${config.cdnUrl}${item.imgSrc}`} alt="logo" />
									</div>
									<p style={{ color: '#444' }}>
										<i>by</i> {item.creatorName}
									</p>
								</div>
							</div>
						</Card>
					</a>
				</Col>
			);
		});

	render() {
		return (
			<div className="homescreen-media-blog">
				<div className="container">
					<h2>In the News</h2>
					<div className="hs-blog-border-bottom"></div>
					{/* <Row > */}
					<div className="hide-for-mobile">
						<Slider {...MediaDesktopsettings}>
							{this.mediaPanelCard(this.props.items)}
						</Slider>
					</div>
					<div className="hide-for-desktop">
						<Slider {...MediaMobilesettings}>
							{this.mediaPanelCard(this.props.items)}
						</Slider>
					</div>
					{/* </Row> */}
				</div>
			</div>
		);
	}
}
